<template>
	<div>
		<div class="lax" data-lax-opacity="0 1, (document.body.scrollHeight*0.2) 0" id="gooo">
			<div data-aos="fade-down" data-aos-easing="ease" :data-aos-delay="delay" class="text-center">
				<p class="nexticon-link" :style="{color: vcolor}">{{title}}</p>
				<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="long-arrow-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline nexticon-arrow" :class="{ 'arrow-bounce': bounce }">
					<path :fill="vcolor" d="M252.485 343.03l-7.07-7.071c-4.686-4.686-12.284-4.686-16.971 0L145 419.887V44c0-6.627-5.373-12-12-12h-10c-6.627 0-12 5.373-12 12v375.887l-83.444-83.928c-4.686-4.686-12.284-4.686-16.971 0l-7.07 7.071c-4.686 4.686-4.686 12.284 0 16.97l116 116.485c4.686 4.686 12.284 4.686 16.971 0l116-116.485c4.686-4.686 4.686-12.284-.001-16.97z" class=""></path>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
import lax from 'lax.js'

export default {
    name: 'NextIcon',
    props: {
		title: String,
		vcolor: String,
		bounce: Boolean,
		delay: {
			type: Number,
			default: 200
		}
	},
    data () {
        return {
            scrollPosition: null
        }
    },
    mounted: function () {
        lax.addElement(document.getElementById('gooo'))
    }
}
</script>

<style lang="scss">
$orange: #f26522;
$white: #FFF;

p.nexticon-link{
	padding: 10px 0; font-size: 20px; display: block; font-weight: 400; text-align: center;
}

svg.nexticon-arrow {
	color: #FFF; width: 25px; height: 100%; text-align: center;
}

.arrow-bounce {
	animation: arrow-bounce 2s infinite;
}

@keyframes arrow-bounce {
	0%, 20%, 50%, 80%, 100% {
		transform: translateY(0);
	}
	40% {
		transform: translateY(-6px);
	}
	60% {
		transform: translateY(-3px);
	}
}

</style>
